import '../bootstrap';
import './icons';
window.Vue = require('vue');

import BootstrapVue from 'bootstrap-vue'

Vue.use(BootstrapVue);

// Base Components
Vue.component('base-map', require('./MapComponents/Base/BaseMap.vue'));
Vue.component('base-view', require('./MapComponents/Base/BaseView.vue'));
Vue.component('layers-container', require('./MapComponents/Base/LayersContainer.vue'));
Vue.component('legend-container', require('./MapComponents/Base/LegendContainer.vue'));
Vue.component('info-window', require('./MapComponents/Base/InfoWindow.vue'));

// Toolbar Components
Vue.component('base-toolbar', require('./MapComponents/Base/BaseToolbar.vue'));
Vue.component('layers-toggle', require('./MapComponents/Toolbar/LayersToggle.vue'));
Vue.component('time-slider', require('./MapComponents/Toolbar/TimeSlider.vue'));

// Layers components
Vue.component('vector-tile', require('./MapComponents/Layers/VectorTile.vue'));
Vue.component('tile-layer', require('./MapComponents/Layers/TileLayer.vue'));

Vue.component('selectable-layer', require('./MapComponents/Layers/SelectableLayer.vue'));
// Source types
Vue.component('tile-source', require('./MapComponents/Layers/TileSource.vue'));
Vue.component('tile-wmts-source', require('./MapComponents/Layers/TileWMTSSource.vue'));
Vue.component('tile-wms-source', require('./MapComponents/Layers/TileWMSSource.vue'));

// Proprietary Types
Vue.component('tile-source-bing-maps', require('./MapComponents/Layers/TileBingMaps.vue'));
/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

// Vue.component('example-component', require('./components/ExampleComponent.vue'));

const app = new Vue({
    el: '#map'
});


// WEBPACK FOOTER //
// ./resources/js/map/app.js